import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'stateList/state',
    initialState: {
        deleteConfirmation: false,
        selectedState: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedState: (state, action) => {
            state.selectedState = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation, 
    setSortedColumn,
    setSelectedState
} = stateSlice.actions

export default stateSlice.reducer
